/*=============================================== SlideshowPage ===============================================*/

import { Slideshow, Image, Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon } from "data"

const SlideshowPage = () => {
    const images: string[] = [
        "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",
        "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",
        "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",
        "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
    ]

    const items: ItemType[] = [
        {
            title: "With controls",
            content: (
                <Slideshow
                    controls={{
                        iconPrev: "arrow-left",
                        iconNext: "arrow-right",
                    }}
                    height={300}
                    pagination={{ variant: "bars" }}
                >
                    {images.map((image, i) => (
                        <Image
                            src={image}
                            alt="Image slideshow"
                            fit="cover"
                            key={i}
                        />
                    ))}
                </Slideshow>
            ),
            code: 'const images = [\n    "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",\n    "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",\n]\n\n<Slideshow\n    controls={{\n        iconPrev: "arrow-left",\n        iconNext: "arrow-right",\n    }}\n    height={300}\n    pagination={{ variant: "bars" }}\n>\n    {images.map((image, i) => (\n        <Image src={image} alt="Image slideshow" fit="cover" key={i} />\n    ))}\n</Slideshow>',
            codeTs: 'const images: string[] = [\n    "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",\n    "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",\n]\n\n<Slideshow\n    controls={{\n        iconPrev: "arrow-left",\n        iconNext: "arrow-right",\n    }}\n    height={300}\n    pagination={{ variant: "bars" }}\n>\n    {images.map((image, i) => (\n        <Image src={image} alt="Image slideshow" fit="cover" key={i} />\n    ))}\n</Slideshow>',
        },
        {
            title: "Autoplay",
            content: (
                <Slideshow height={300} options={{ autoplay: 3000 }}>
                    {images.map((image, i) => (
                        <Image
                            src={image}
                            alt="Image slideshow"
                            fit="cover"
                            key={i}
                        />
                    ))}
                </Slideshow>
            ),
            code: 'const images = [\n    "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",\n    "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",\n]\n\n<Slideshow height={300} options={{ autoplay: 3000 }}>\n    {images.map((image, i) => (\n        <Image src={image} alt="Image slideshow" fit="cover" key={i} />\n    ))}\n</Slideshow>',
            codeTs: 'const images: string[] = [\n    "https://images.unsplash.com/photo-1636390785258-f59cd6883a03?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1636390785299-b4df455163dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80",\n    "https://images.unsplash.com/photo-1634705146926-b8fbca28f431?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1928&q=80",\n    "https://images.unsplash.com/photo-1636207543865-acf3ad382295?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",\n]\n\n<Slideshow height={300} options={{ autoplay: 3000 }}>\n    {images.map((image, i) => (\n        <Image src={image} alt="Image slideshow" fit="cover" key={i} />\n    ))}\n</Slideshow>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "activeSlide",
            type: "number",
        },
        {
            subtitle: "height",
            type: "number or string",
            default: "30vw",
        },
        {
            subtitle: "thumbnails",
            intro: (
                <>
                    Only if <code>pagination</code> is not defined. Here, we
                    want an <code>array</code> of the pages shown in the{" "}
                    <code>Slideshow</code>.
                </>
            ),
            type: "array of strings",
        },
        "separator",
        {
            subtitle: "pagination",
            intro: (
                <>
                    Only if <code>thumbnails</code> is not defined.
                </>
            ),
            type: "boolean or object",
        },
        {
            title: (
                <>
                    <code>pagination</code> object
                </>
            ),
            subtitle: "variant",
            type: "string",
            possible: ["dots", "dots-outline", "bars"],
            default: "dots",
        },
        {
            subtitle: "position",
            type: "string",
            possible: ["inside", "outside"],
            default: "outside",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "hideTouchScreens",
            intro: "Hides the pagination on touch screens.",
            type: "boolean",
        },
        "separator",
        {
            subtitle: "controls",
            type: "boolean or object",
        },
        {
            title: (
                <>
                    <code>controls</code> object
                </>
            ),
            subtitle: "type",
            type: "string",
            possible: ["small", "large"],
            default: "small",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "hideTouchScreens",
            intro: "Hides the buttons on touch screens. In any case, slide gestures are enabled.",
            type: "boolean",
        },
        {
            subtitle: "iconPrev",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("chevron-left"),
        },
        {
            subtitle: "iconNext",
            type: "string",
            default: iconBoxicon("chevron-right"),
        },
        "separator",
        {
            subtitle: "options",
            type: "object",
        },
        {
            title: (
                <>
                    <code>options</code> object
                </>
            ),
            subtitle: "autoplay",
            intro: (
                <>
                    In <code>ms</code>.
                </>
            ),
            type: "number",
            default: 1500,
        },
        {
            subtitle: "speed",
            intro: (
                <>
                    In <code>ms</code>.
                </>
            ),
            type: "number",
            default: 1000,
        },
    ]

    return (
        <ComponentsLayout items={items} propsItems={propsItems}>
            <Text>
                By default, the <code>Slideshow</code> is with{" "}
                <code>autoplay</code> with a <code>speed</code> of{" "}
                <code>1500ms</code>.
            </Text>
        </ComponentsLayout>
    )
}

export default SlideshowPage
